<template>
  <div>
    <v-autocomplete
      v-show="!hiddenField(access)"
      :items="formattedItems()"
      item-text="value"
      item-value="key"
      item-color="color"
      :id="id"
      :label="label"
      v-model="currentValue"
      :type="fieldTextType(dataType)"
      @input="handleChange"
      :required="requiredField(access)"
      :readonly="readonlyField(access)"
      :disabled="loading"
      :filled="readonlyField(access) || queryFlag"
      :rules="rules"
      :clearable="optionalField(access)"
      :loading="loading"
      :outlined="queryFlag"
      :dense="queryFlag"
      :single-line="queryFlag"
      :hide-details="queryFlag"
      :style="queryFlag ? 'font-size: 0.9em' : null"
      autocomplete="off"
    >
      <template v-slot:selection="data">
        <v-icon small :color="data.item.color" v-if="data.item.icon">{{ data.item.icon }}</v-icon>
        {{ data.item.value }}
      </template>

      <template v-slot:item="data">
        <template>
          <v-list-item-avatar v-if="data.item.icon">
            <v-icon small :color="data.item.color">{{ data.item.icon }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-html="data.item.value"></v-list-item-title>
            <!--
            <v-list-item-subtitle
              v-html="data.item.value"
            ></v-list-item-subtitle>
            -->
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "ComboField",
  props: [
    "label",
    "value",
    "access",
    "pattern",
    "id",
    "items",
    "name",
    "rules",
    "tags",
    "dataType",
    "loading",
    "queryFlag",
    "coordinates",
    "generalExApplicationEx",
    "customLanguage",
  ],
  data() {
    let stringValue = this.value
      ? typeof this.value == "string"
        ? this.value
        : this.value.toString()
      : null;
    return {
      defaultValue: this.value,
      currentValue: this.value,
      tagsValue: stringValue ? stringValue.split(",") : [],
      autoSource: null,
      delimiter: " ",
      search: null,
    };
  },
  methods: {
    handleChange() {
      let handledValue = null;
      handledValue = this.currentValue;
      const data = {
        value: handledValue,
        id: this.id,
        autoSource: this.autoSource,
        coordinates: this.coordinates,
      };
      this.$emit("field-change", data);
    },
    setValue(value, autoSource) {
      this.currentValue = value;
      this.autoSource = autoSource;
      this.handleChange();
    },
    formattedItems() {
      const keyFieldName = "itemId";
      const valueFieldName = "itemName";
      const colorFieldName = "itemColor";
      const iconFieldName = "itemIcon";
      const translatedValueFieldName = this.translatedKey(
        this.generalExApplicationEx,
        this.customLanguage,
        valueFieldName
      );
      const empties =
        translatedValueFieldName != valueFieldName
          ? this.items.find((item) => !item[translatedValueFieldName])
          : false;
      const result = this.items.map((item) => {
        return {
          key: item[keyFieldName],
          value: empties
            ? item[valueFieldName]
            : item[translatedValueFieldName],
          color: item[colorFieldName],
          icon: item[iconFieldName],
        };
      });
      return result;
    },
  },
  updated() {},
};
</script>

<style scoped>
</style>